import React, { Component } from "react";
import { connect } from "react-redux";
import { searchDoctors, getDoctorAnalyses, getDoctorPacks, copyPackToPrescriber } from "services/doctor";
import { adminPostAnalysesPack, adminPatchAnalysesPack } from "services/analysesPack";
import { Icon, Button, Label, List, Grid, Header, Item, Message, Card, Segment, Modal } from "semantic-ui-react";
import debounce from "lodash.debounce";
import AsyncFilterSelect from "components/Form/AsyncFilterSelect";
import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import { doctorHandleInputChange } from "utils/selectOptions";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { Checkbox } from "components/Form/SpecialButtons";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
		height: "100%",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
	roundHeaderContainer: {
		color: "white",
		height: 40,
		backgroundColor: "#43b39e",
		width: "100%",
		padding: 10,
		display: "flex",
		borderRadius: "4px 4px 0 0",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		position: "relative",
	},
};
const schemaValidation = Yup.object().shape({
	label: Yup.string().required("Champ requis"),
	color: Yup.string().required("Champ requis"),
});

class AnalysesPacksPrescriber extends Component {
	constructor(props) {
		super(props);

		this.state = {
			doctorLoading: false,
			result: [],
			total: 0,
			packs: null,
			selectedPack: null,
			openCopyPack: false,
		};
	}

	getDoctorAnalyses = (doctor, min_count, withCovid) => {
		this.props.getDoctorAnalyses(doctor.code || doctor.id, min_count, withCovid).then((res) => {
			if (res.payload.data) {
				this.setState({ result: res.payload.data.result });
				this.setState({ total: parseInt(res.payload.data.total) });
			}
		});
	};

	copyPackToPrescriber = (doctor) => {
		this.props.copyPackToPrescriber(
			this.state.selectedPack.id,
			doctor.code || doctor.id,
			[doctor.title, doctor.last_name, doctor.code].filter((e) => !!e).join(" "),
			this.state.selectedPack.name
		);
		this.setState({ openCopyPack: false });
	};

	getDoctorPacks = (doctorCode, doctorId) => {
		this.props.getDoctorPacks(doctorCode, doctorId).then((res) => {
			if (res.payload.data) {
				this.setState({ packs: res.payload.data.packs });
			}
		});
	};
	createAnalysesPack = (doctor, packs) => {
		const values = {
			color: "#fff",
			group: "PRESCRIPTEUR",
			name: "",
			label: `${[doctor.title, doctor.last_name, doctor.code].filter((e) => !!e).join(" ")} ${packs.length > 0 ? packs.length + 1 : ""}`,
			doctor: doctor.code || doctor.id,
			analysesTmp: { value: [] },
		};
		this.props.adminPostAnalysesPack(values).then((res) => this.getDoctorPacks(doctor.code, doctor.id));
	};

	addAnalyseToPack = (analyse) => {
		const values = {
			...this.state.selectedPack,
			analysesTmp: {
				value: this.state.selectedPack.analysesTmp.value.push(analyse.id),
			},
		};
		this.props.adminPatchAnalysesPack(this.state.selectedPack).then((res) => {
			let packs = this.state.packs;
			let i = packs.findIndex((p) => p.id === res.payload.data.id);
			packs[i] = res.payload.data;
			this.setState({
				packs: packs,
				selectedPack: {
					...res.payload.data,
					analysesTmp: {
						value: res.payload.data.analysesPackages.map((p) => p.analysis.id),
					},
				},
			});
		});
	};

	removeAnalyseFromPack = (analyse) => {
		const values = {
			...this.state.selectedPack,
			analysesTmp: {
				value: this.state.selectedPack.analysesTmp.value.filter((id) => id !== analyse.id),
			},
		};
		this.props.adminPatchAnalysesPack(values).then((res) => {
			let packs = this.state.packs;
			let i = packs.findIndex((p) => p.id === res.payload.data.id);
			packs[i] = res.payload.data;
			this.setState({
				packs: packs,
				selectedPack: {
					...res.payload.data,
					analysesTmp: {
						value: res.payload.data.analysesPackages.map((p) => p.analysis.id),
					},
				},
			});
		});
	};

	filterDoctors = debounce((searchTerm, callback) => {
		this.props
			.searchDoctors({ multiple_search: searchTerm }, 30, 0)
			.then(() => {
				this.setState({ doctorLoading: false });
				callback(
					this.props.doctors.list
						.filter((d) => d.exists)
						.map((doctor) => {
							return {
								value: doctor.id,
								label: `${doctor.code || ""} - ${doctor.last_name} ${doctor.first_name} - ${doctor.speciality} - ${doctor.address.street} ${
									doctor.address.postal_code
								} ${doctor.address.city}`,
								labels: [
									{ text: doctor.code, width: 10 },
									{ text: doctor.last_name, width: 20 },
									{ text: doctor.first_name, width: 20 },
									{ text: doctor.speciality, width: 10 },
									{ text: doctor.address?.street, width: 20 },
									{ text: doctor.address?.postal_code, width: 5 },
									{ text: doctor.address?.city, width: 15 },
								],
								...doctor,
								sil_id: doctor.external_id,
								mylab_id: doctor.id,
							};
						})
				);
			})
			.catch((error) => {
				this.setState({ doctorLoading: false });
				callback(error);
			});
	}, 500);
	render() {
		return (
			<Grid
				textAlign="left"
				style={{
					maxWidth: 950,
					height: "95vh",
					margin: "50px auto",
					...styles.blocWhite,
				}}
				verticalAlign="top"
			>
				<Grid.Row style={styles.blocHeader}>
					<Grid.Column computer={12} tablet={13} mobile={12} style={{ color: "white" }}>
						Packs d'analyses par prescripteur
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column style={{ margin: "auto", height: "80vh" }}>
						<Formik
							initialValues={{
								doctor: null,
								doctorToCopy: null,
								min_count: 0,
								withCovid: false,
							}}
							validationSchema={schemaValidation}
						>
							{({ values, setFieldValue }) => {
								return (
									<Form>
										<Field
											component={AsyncFilterSelect}
											defaultValue={values.doctor}
											name="doctor"
											customlabel="Médecin"
											promiseOptions={(searchTerm, callback) => {
												this.setState({ doctorLoading: true });
												return this.filterDoctors(searchTerm, callback);
											}}
											onInputChange={doctorHandleInputChange}
											isLoading={this.state.doctorLoading}
											placeholder="Sélectionner un médecin"
											customOnChange={(option) => {
												setFieldValue("doctor", option);
												this.getDoctorPacks(option.code, option.id);
												this.getDoctorAnalyses(option, 0, false);
											}}
										/>

										{values.doctor && (
											<Grid divided="vertically" celled style={{ margin: "20px 5px" }}>
												<Grid.Row columns={2}>
													<Grid.Column>
														<div style={styles.blocHeader}>Packs enregistrés</div>
														<Segment placeholder>
															<Header icon>
																<Icon name="object ungroup" />
															</Header>

															<Button
																primary
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.getDoctorPacks(values.doctor.code, values.doctor.id);
																}}
																disabled={!values.doctor}
															>
																Rechercher les packs
															</Button>
														</Segment>
														{this.state.packs && (
															<Segment>
																{this.state.packs.length > 0 && (
																	<Card.Group itemsPerRow="1">
																		{this.state.packs.map((item) => (
																			<Card
																				key={`pack-${item.id}`}
																				style={{
																					border: this.state.selectedPack && this.state.selectedPack.id === item.id ? "3px solid teal" : "inherit",
																				}}
																				onClick={() =>
																					this.setState({
																						selectedPack: {
																							...item,
																							analysesTmp: {
																								value: item.analysesPackages.map((p) => p.analysis.id),
																							},
																						},
																					})
																				}
																			>
																				<Card.Content>
																					<Card.Header>
																						Pack {item.label}{" "}
																						<div style={{ fontStyle: "italic", fontSize: "0.9rem", color: "grey" }}>{item.name}</div>
																					</Card.Header>
																				</Card.Content>
																				<Card.Content extra>
																					{item.analysesPackages && item.analysesPackages.length > 0 && (
																						<List>
																							{item.analysesPackages.map((p) => (
																								<List.Item key={`list-item-${p.analysis.id}`}>
																									<Label>
																										<b>{p.analysis.code}</b> <i>({p.analysis.label})</i>{" "}
																										{this.state.selectedPack && this.state.selectedPack.id === item.id && (
																											<Icon name="delete" color="red" onClick={() => this.removeAnalyseFromPack(p.analysis)} />
																										)}
																									</Label>
																								</List.Item>
																							))}{" "}
																						</List>
																					)}
																				</Card.Content>
																				{this.state.selectedPack && this.state.selectedPack.id === item.id && (
																					<Card.Content extra>
																						<Button basic color="teal" onClick={() => this.setState({ openCopyPack: true })}>
																							Copier ce pack à un autre prescripteur
																						</Button>
																						<Modal open={this.state.openCopyPack}>
																							<Modal.Header>Copie d'un pack à un autre prescripteur</Modal.Header>
																							<Modal.Content>
																								<Field
																									component={AsyncFilterSelect}
																									defaultValue={values.doctor}
																									name="doctorToCopy"
																									customlabel="Prescripteur"
																									promiseOptions={(searchTerm, callback) => {
																										this.setState({ doctorLoading: true });
																										return this.filterDoctors(searchTerm, callback);
																									}}
																									onInputChange={doctorHandleInputChange}
																									isLoading={this.state.doctorLoading}
																									placeholder="Sélectionner un médecin"
																									customOnChange={(option) => {
																										setFieldValue("doctorToCopy", option);
																									}}
																								/>
																							</Modal.Content>
																							<Modal.Actions>
																								<Button onClick={() => this.setState({ openCopyPack: false })}>Annuler</Button>
																								<Button
																									color="teal"
																									disabled={!values.doctorToCopy || values.doctorToCopy.id === values.doctor.id}
																									onClick={() => this.copyPackToPrescriber(values.doctorToCopy)}
																								>
																									Copier
																								</Button>
																							</Modal.Actions>
																						</Modal>
																					</Card.Content>
																				)}
																			</Card>
																		))}
																	</Card.Group>
																)}
																{this.state.packs.length === 0 && (
																	<Header icon>
																		<Icon name="lab" />
																		Aucun pack d'analyses associé à ce prescripteur
																	</Header>
																)}
																{values.doctor && (
																	<Button style={{ margin: "15px 5px" }} onClick={() => this.createAnalysesPack(values.doctor, this.state.packs)}>
																		<Icon name="plus" /> Créer un nouveau pack d'analyses
																	</Button>
																)}
															</Segment>
														)}
													</Grid.Column>
													<Grid.Column>
														<div style={styles.blocHeader}>Prescriptions</div>
														<Grid>
															<Grid.Row columns="2">
																<Grid.Column>
																	<Field
																		type="number"
																		name="min_count"
																		customlabel="Nombre minimal de prescriptions à atteindre par analyse"
																		component={CustomInputTextComponent}
																	/>
																	<Field id="withCovid" name="withCovid" customlabel="Covid inclus" component={Checkbox} />
																</Grid.Column>
																<Grid.Column>
																	<Segment placeholder>
																		<Header icon>
																			<Icon name="lab" />
																		</Header>
																		<Button
																			primary
																			onClick={(e) => {
																				if (e !== undefined) e.preventDefault();
																				this.getDoctorAnalyses(values.doctor, values.min_count, values.withCovid);
																			}}
																			disabled={!values.doctor}
																		>
																			Rechercher les analyses prescrites
																		</Button>
																	</Segment>
																</Grid.Column>
															</Grid.Row>
														</Grid>

														<Segment>
															{this.state.total > 0 && (
																<Message>
																	<Message.Header>{this.state.total} prescriptions ont été trouvées pour ce médecin dans MyLabNurse</Message.Header>
																</Message>
															)}
															{this.state.result && (
																<List divided relaxed>
																	{this.state.result.map((item, index) => (
																		<List.Item key={`analysis-count-${index}`}>
																			<List.Content>
																				<List.Header>
																					<Label>
																						<b>{item.analysis.code}</b> <i>({item.analysis.label})</i>{" "}
																						{this.state.selectedPack &&
																							this.state.selectedPack.analysesPackages &&
																							this.state.selectedPack.analysesPackages.filter((p) => p.analysis.id === item.analysis.id).length ===
																								0 && (
																								<Label as="a" color="teal" onClick={() => this.addAnalyseToPack(item.analysis)}>
																									<Icon name="add circle" /> Ajouter au pack{" "}
																								</Label>
																							)}
																					</Label>
																				</List.Header>
																				<Label color="teal" as="span">
																					{item.count}
																				</Label>
																			</List.Content>
																		</List.Item>
																	))}
																</List>
															)}
														</Segment>
													</Grid.Column>
												</Grid.Row>
											</Grid>
										)}
									</Form>
								);
							}}
						</Formik>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		doctors: state.doctors,
	};
};

const mapDispatchToProps = {
	searchDoctors,
	getDoctorAnalyses,
	getDoctorPacks,
	adminPostAnalysesPack,
	adminPatchAnalysesPack,
	copyPackToPrescriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalysesPacksPrescriber);
